import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";

function HomeScreen() {
	return <ContainerScreen hasBackground />;
}

export default HomeScreen;
